import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { SubSink } from 'subsink';

import { MerchantActions } from '@merchant/store/merchant.slice';

@Component({
  selector: 'app-view-merchant',
  templateUrl: './view-merchant.component.html',
  styleUrls: ['./view-merchant.component.scss'],
})
export class ViewMerchantComponent implements OnInit, OnDestroy {
  merchantName?: string;
  siteId?: string;

  subs = new SubSink();

  navLinks: any[];
  activeLinkIndex = -1;

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private translate: TranslateService,
    private router: Router
  ) {
    this.navLinks = [
      {
        label: this.translate.get('MERCHANT.BASIC.TITLE'),
        link: 'basic-data',
      },
      {
        label: this.translate.get('MERCHANT.SITES.TITLE'),
        link: 'sites',
      },
    ];
  }

  ngOnInit(): void {
    this.subs.add(
      this.route.params.subscribe((params) => {
        if (params['merchantId']) {
          this.store.dispatch(
            MerchantActions.loadMerchantById.trigger({
              id: params['merchantId'],
            })
          );
          this.store.dispatch(
            MerchantActions.loadSitesByMerchantId.trigger({
              merchantId: params['merchantId'],
            })
          );
        }
      })
    );

    this.subs.add(
      this.route.queryParams.subscribe((params) => {
        if (params['merchantName']) {
          this.merchantName = params['merchantName'];
        }
        if (params['siteId']) {
          this.siteId = params['siteId'];
        }
      })
    );

    this.subs.add(
      this.router.events.subscribe(() => {
        this.activeLinkIndex = this.navLinks.indexOf(
          this.navLinks.find((tab) => tab.link === '.' + this.router.url)
        );
      })
    );
  }

  onCancel() {
    history.back();
  }

  ngOnDestroy(): void {
    this.store.dispatch(MerchantActions.resetSites());
    this.subs.unsubscribe();
  }
}
